import { render } from "./Report.vue?vue&type=template&id=2a511473&scoped=true"
const script = {}

import "./Report.vue?vue&type=style&index=0&id=2a511473&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a511473"

export default script